import Vue from "vue";
import Vuex from "vuex";
import Auth from "./auth";
import vuexI18n from "vuex-i18n";
import translationsEn from "@/locale/en";
import translationsAr from "@/locale/ar";
import rules from "./rules";

Vue.use(Vuex);
const state = {
  curLanguage: { short: "ar", long: "Arabic" },
  languages: [
    {
      short: "ar",
      long: "Arabic"
    },
    {
      short: "en",
      long: "English"
    }
  ],
  direction: true,

  title: localStorage.getItem("title") || "لجامعات الخاصة|Private Universities",
  logo: localStorage.getItem("logo") || "@/assets/images/_Logo.png",
  profileImage: localStorage.getItem("profileImage") || "/user_avatar.png"
};
const mutations = {
  setLanguage(state, lang) {
    state.curLanguage = lang;
    state.direction = lang === "ar";
  },
  setUniversity(state, payload) {
    state.title = payload.name;
    state.logo = payload.logo;
  },
  profileImage(state, profileImage) {
    state.profileImage = profileImage;
  }
};
const getters = {
  getUniversityTitle: state => state.title,
  getUniversityLogo: state => state.logo,
  getLanguage: state => (state.direction ? "ar" : "en")
};
/* eslint-disable no-new */
const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  modules: {
    Auth,
    rules
  }
});
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add("en", translationsEn);
Vue.i18n.add("ar", translationsAr);
Vue.i18n.set(localStorage.lang);

export default store;
